import React, {useState, useEffect} from "react";
import PreDeliveryInspectionLocation from "../pre-delivery-inspection-location";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import PropTypes from "prop-types";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiLeadCreated, confirmLocation } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionLocationWithLogin = ({
    fetchLeadDetailsConnect,
    fetchSlotsConnect,
    setPositionConnect,
    secureToken,
    mobile,
    history,
    createPDILeadConnect,
    brand,
    model,
    close = () => {},
    registrationNumber,
    leadToken,
    updatePDILeadConnect,
    newCarPdiLead,
    intent
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [landmark, setLandmark] = useState(null);
    const [address, setAddress] = useState(null);
    const [token, setToken] = useState(null);
    const { text: intentText = ""} = intent || {};

    const handleConfirm = (data = {}) => {
        const { pvtToken = secureToken, phone_number: phoneNumber = mobile } = data || {};
        const payload = {
            make_id: brand && brand.id,
            model_id: model && model.id,
            phone: phoneNumber,
            source: C2B_LEAD_TYPES.CAR_TRUTH_VAS,
            verified_source: "verified",
            new_cars_pdi_lead: newCarPdiLead,
            pdi_booked_by: intentText,
            ...(registrationNumber && {vehicle_reg_no: registrationNumber})
        };
        const pdiLeadFn = leadToken ? updatePDILeadConnect : createPDILeadConnect;
        pdiLeadFn({
            payload,
            secureToken: pvtToken,
            ...(leadToken && {token: leadToken})
        }).then(async(response) => {
            setToken(response);
            await yieldToMain();
            if (!leadToken) {
                sendCustomGaEvents({
                    ...pdiLeadCreated,
                    eventLabel: response
                });
            }
        }).catch(() => { });
    };

    useEffect(() => {
        if (secureToken && mobile) {
            handleConfirm({phone_number: mobile});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureToken, mobile]);

    const handleCallBack = ({ lat: selectedLat, lng: selectedLng }) => {
        setIsLoading(true);
        setPositionConnect({ lat: selectedLat, lng: selectedLng });
        fetchSlotsConnect({
            lat: selectedLat,
            lng: selectedLng,
            ...(token && { leadToken: token })
        }, true)
            .then(async() => {
                setIsLoading(false);
                close();
                await yieldToMain();
                history.push(`/pre-delivery-inspection/slot/${token}`);
                sendCustomGaEvents({
                    ...confirmLocation,
                    eventLabel: token
                });
            })
            .catch(() => {
                setIsLoading(false);
                close();
            });
    };

    return (
        <PreDeliveryInspectionLocation
            isLoading={isLoading}
            isOpen={token}
            setIsOpen={close}
            handleConfirmLocation={handleCallBack}
            token={token && token}
            setAddressConnect={setAddress}
            setLandmarkConnect={setLandmark}
            address1={address}
            landmark={landmark}
            fetchLeadDetailsConnect={fetchLeadDetailsConnect}
            secureToken={secureToken}
        />
    );
};

PreDeliveryInspectionLocationWithLogin.propTypes = {
    fetchLeadDetailsConnect: PropTypes.func,
    fetchSlotsConnect: PropTypes.func,
    setPositionConnect: PropTypes.func,
    secureToken: PropTypes.string,
    mobile: PropTypes.string,
    history: PropTypes.object,
    createPDILeadConnect: PropTypes.func,
    brand: PropTypes.object,
    model: PropTypes.object,
    close: PropTypes.func,
    registrationNumber: PropTypes.string,
    showInModal: PropTypes.bool,
    updatePDILeadConnect: PropTypes.func,
    leadToken: PropTypes.string,
    newCarPdiLead: PropTypes.any,
    intent: PropTypes.object
};

export default PreDeliveryInspectionLocationWithLogin;
